import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Form } from "react-bootstrap";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  chgEspaceFilter,
  chgPartieprenanteFilter,
  chgRituelFilter,
  chgRoleFilter,
  chgTempscollectifFilter,
  selectInGouvernanceFilters,
} from "../../../redux/ReduxFilter";

const BlocFiltreFakeInGovernance = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _selectInGouvernanceFilters = useSelector(selectInGouvernanceFilters);
  const navigate = useNavigate();

  return (
    <div className="sliderSticky">
      <div className="enteteBlocFiltre">
        <span>{t("public.filtres.filtre22")}</span>
      </div>
      <Container fluid className="mb-3 d-flex align-items-center flex-nowrap containerFiltres">
        <div className="m-1 border align-items-center d-flex">
          <Link to={"/inGovernance"}>
            <Form.Check
              className="filtreActif"
              type="checkbox"
              label={t("public.filtres.filtre1")}
              defaultChecked="checked"
            />
          </Link>
        </div>
        <div
          className="m-1 border align-items-center d-flex"
          onClick={(e) => {
            dispatch(chgEspaceFilter(true));
            navigate("/ingovernance");
          }}
        >
          <Form.Check type="checkbox" label={t("public.filtres.filtre2")} />
        </div>
        <div
          className="m-1 border align-items-center d-flex"
          onClick={(e) => {
            dispatch(chgRituelFilter(true));
            navigate("/ingovernance");
          }}
        >
          <Form.Check type="checkbox" label={t("public.filtres.filtre3")} />
        </div>
        <div
          className="m-1 border align-items-center d-flex"
          onClick={(e) => {
            dispatch(chgTempscollectifFilter(true));
            navigate("/ingovernance");
          }}
        >
          <Form.Check type="checkbox" label={t("public.filtres.filtre4")} />
        </div>
        <div
          className="m-1 border align-items-center d-flex"
          onClick={(e) => {
            dispatch(chgRoleFilter(true));
            navigate("/ingovernance");
          }}
        >
          <Form.Check type="checkbox" label={t("public.filtres.filtre5")} />
        </div>
        <div
          className="m-1 border align-items-center d-flex"
          onClick={(e) => {
            dispatch(chgPartieprenanteFilter(true));
            navigate("/ingovernance");
          }}
        >
          <Form.Check type="checkbox" label={t("public.filtres.filtre6")} />
        </div>
      </Container>
    </div>
  );
};

export default BlocFiltreFakeInGovernance;
